export default (params) => {
    const tourCriteria = {};

    const element = params.hotels;
    if (element) {
        tourCriteria.hotels = element.split('.');
    }

    return tourCriteria;
};